<div class="dsgnr-wrap">
  <main class="dsgnr-body" role="main">

    <div style="height:44px"></div>

    <section class="section-layout-block section-with-card">
      <div class="container single-content-layout-layout-block mb-5">

        <!-- Header -->
        <div class="row justify-content-center text-center">
          <div class="col-12 card-like card-like-lg">
            <h1 class="h4 watersharing-card-title">
              {{ type === 'trade' ? '— Trade Stats Dashboard' : '— Share Stats Dashboard' }}
            </h1>
          </div>
        </div>

        <!-- Tabs -->
        <ul class="nav nav-pills mb-0 mt-4" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active"
                    id="global-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#global"
                    type="button"
                    role="tab"
                    aria-selected="true">
              Global
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link"
                    id="personal-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#personal"
                    type="button"
                    role="tab"
                    aria-selected="false">
              Personal
            </button>
          </li>
        </ul>

        <div class="tab-content mt-3">

          <!-- Global Tab -->
          <div class="tab-pane fade show active" id="global" role="tabpanel">
            <div class="stats-row">
              <div class="stats-col">
                <div class="watertrading-blocks">
                  <strong>Total trades to date</strong>
                  <div class="watersharing-col-third">
                    <span class="heading">{{ globalStats.tradesToDate || 0 }} trades</span>
                  </div>
                </div>
              </div>
              <div class="stats-col">
                <div class="watertrading-blocks">
                  <strong>Total trades proposed</strong>
                  <div class="watersharing-col-third">
                    <span class="heading">{{ globalStats.tradesProposed || 0 }} trades</span>
                  </div>
                </div>
              </div>
              <div class="stats-col">
                <div class="watertrading-blocks">
                  <strong>Total volume traded</strong>
                  <div class="watersharing-col-third">
                    <span class="heading">{{ globalStats.volumeTraded || 0 }} bbl</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="chart">
              <canvas id="stat-chart-global" height="300"></canvas>
            </div>
          </div>

          <!-- Personal Tab -->
          <div class="tab-pane fade" id="personal" role="tabpanel">
            <div class="row text-center mb-4">
              <div class="col-md-4 mb-4 mb-md-0">
                <div class="watertrading-blocks">
                  <strong>Total trades to date</strong>
                  <div class="watersharing-col-third">
                    <span class="heading">{{ personalStats.tradesToDate || 0 }} trades</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4 mb-4 mb-md-0">
                <div class="watertrading-blocks">
                  <strong>Total trades proposed</strong>
                  <div class="watersharing-col-third">
                    <span class="heading">{{ personalStats.tradesProposed || 0 }} trades</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="watertrading-blocks">
                  <strong>Total volume traded</strong>
                  <div class="watersharing-col-third">
                    <span class="heading">{{ personalStats.volumeTraded || 0 }} bbl</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="chart">
              <canvas id="stat-chart-personal" height="300"></canvas>
              <!--<button class="watersharing-submit-button mt-3"
                      (click)="downloadCsv()">
                Download My Stats
              </button>-->
            </div>
          </div>

        </div>

      </div>
    </section>

  </main>
</div>
